import React from 'react';
import './Policy.css';

const RefundPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container padding">
        <div className="heading">
          <h2>Refund Policy</h2>
        </div>
        <div className="policy-content">
          <div className="policy-card">
            <h3>No Refunds</h3>
            <p>
              We have a strict no refund policy. Once Donation is made, no refunds will be issued under any circumstances. 
              We encourage customers to thoroughly review product descriptions before making a purchase, as all transactions 
              made for Donation are final.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;

